import { gql } from '@apollo/client';

export const QUERY_ADVANCED_FILTERS = gql`
  query AdvancedFilters($filters: AdvancedFilterInput, $language: String) {
    advancedFilterOptions(filters: $filters, language: $language) {
      filters {
        biome {
          name
          value
          available
        }
        region {
          name
          value
          available
        }
        state {
          name
          value
          available
        }
        intermediate_region {
          name
          value
          available
        }
        immediate_region {
          name
          value
          available
        }
      }
      total_municipalities
    }
  }
`;
